import { Graphql, client as gqlClient } from './Graphql';

export { Graphql, gqlClient };
